import { BCMSRecord, useBCMSContext } from "@bcm-dev/bcms-vite";
import Classes from "model";
import EDEStatementsEnrollmentPreferencesPage from "components/EDEStatements/pages/EDEStatementsEnrollmentPreferencesPage";

/**
 * @name CaptureMabiEDEStatementsEnrollmentStatementNotificationDefault
 * @returns {React.Component}
 * @description A capture in the MABI23 "Statement Preferences (EDE)" capture group.
 */
export default function CaptureMabiEDEStatementsEnrollmentStatementNotificationDefault(props) {
    const context = useBCMSContext();
    BCMSRecord.globalControllerFor(Classes, context);

    return <EDEStatementsEnrollmentPreferencesPage />;
}